var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_c('v-app',{staticClass:"p-4"},[_c('BankCards',{attrs:{"phone":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }